import DashboardBuilder from 'dashboard-builder';

const Builder = () => <DashboardBuilder baseURL={`${process.env.REACT_APP_SERVICE_URL}/mSurvey/api/`} />;

export default Builder;
